import clsx from "clsx"
import { Loader2 } from "lucide-react"
import React from "react"

/**
 * @description 로딩 스피너. 회전 애니메이션이 적용된 원형 아이콘
 * @example
 * <TLoader />
 * <TLoader size={24} />
 */
interface TLoaderProps {
	/**
	 * 스피너 크기 (px)
	 * @default 16
	 */
	size?: number
	/** 추가 CSS 클래스 */
	className?: string
}

export const TLoader = React.memo((props: TLoaderProps) => {
	const { size = 16, className } = props

	return (
		<div className={clsx("flex justify-center items-center h-full", className)}>
			<Loader2 className="animate-spin aspect-square text-text" aria-hidden="true" style={{ width: size, height: size }} />
		</div>
	)
})

TLoader.displayName = "TLoader"
